import { Component, effect, inject, input, signal, untracked } from '@angular/core';
import { TranslateModule }                                      from '@ngx-translate/core';

import { BlastService }                from 'src/app/services/blast.service';
import { UtilisateurService }          from 'src/app/services/utilisateur.service';
import { MetabaseDashboardComponent }  from 'src/app/shared/components/metabase-dashboard/metabase-dashboard.component';

const FLEET_BLAST_FILTER_SITE_ID = 189;

/** Onglet Fleet Management System de l'ancien front (tir-detail, onglet 10). */
@Component({
  selector:   'app-legacy-blast-fleet',
  standalone: true,
  imports:    [MetabaseDashboardComponent, TranslateModule],
  template: `
    @if (loaded()) {
      <app-metabase-dashboard componentSelector="app-tir-detail" class="w-100" [blast]="blastName()" />
    } @else if (failed()) {
      <p class="fleet-error">
        {{ 'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
        <button type="button" class="btn btn-link p-0" (click)="init(blastId())">{{ 'HOLES_TAB.RETRY' | translate }}</button>
      </p>
    }
  `,
  styles: [':host { display: block; width: 100%; }', '.fleet-error { padding: 1rem; }'],
})
export class LegacyBlastFleetComponent {
  readonly blastId = input.required<number>();

  private readonly blastService = inject(BlastService);
  private readonly user         = inject(UtilisateurService);

  protected readonly blastName = signal('');
  protected readonly loaded    = signal(false);
  protected readonly failed    = signal(false);

  constructor() {
    effect(() => {
      const blastId = this.blastId();
      untracked(() => this.init(blastId));
    });
  }

  /** Comme TirDetailComponent.changerTab(10) : le nom du tir n'est transmis au dashboard que pour le site 189. */
  protected init(blastId: number): void {
    this.loaded.set(false);
    this.failed.set(false);
    this.blastName.set('');

    if (this.user.currentSite()?.siteId !== FLEET_BLAST_FILTER_SITE_ID) {
      this.loaded.set(true);
      return;
    }

    this.blastService.getBlast(blastId).subscribe({
      next: tir => {
        if (blastId !== this.blastId()) return;
        this.blastName.set(tir?.nom ?? '');
        this.loaded.set(true);
      },
      error: () => {
        if (blastId === this.blastId()) this.failed.set(true);
      },
    });
  }
}
